import { Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel } from "@material-ui/core";
import React from "react";
import { RawLinkButton } from "../../../LinkButton";
import IIntegration from "../../../../models/IIntegration";
import { DialogContentErrorText } from "../../../../functions/errorHandling";
import IIntegrationRepository from "../../../../services/IIntegrationRepository";
import Services from "../../../../services/Services";

export interface IBeginDevelopmentDialogProps {
  showDialog: boolean;
  token: string;
  integration: IIntegration;
  onClose: () => void;
  onSuccess: () => void;
}

export const BeginDevelopmentDialog = (props: IBeginDevelopmentDialogProps): JSX.Element => {
  const { showDialog, token, integration, onClose, onSuccess } = props;

  const [checkNameDescription, setCheckNameDescription] = React.useState<boolean>(false);
  const [checkDataDirection, setCheckDataDirection] = React.useState<boolean>(false);
  const [checkAPIs, setCheckAPIs] = React.useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleSubmit = async () => {
    setError(null);
    setIsSubmitting(true);
    try {
      const repo: IIntegrationRepository = await new Services().IntegrationRepository();
      await repo.beginDevelopment(token, integration);
      onSuccess();
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Unknown error");
      }
    }

    setIsSubmitting(false);
  };

  const isComplete = checkNameDescription && checkDataDirection && checkAPIs;

  return (
    <Dialog open={showDialog}>
      <DialogTitle>Begin Integration Development</DialogTitle>
      <DialogContent>
        <DialogContentText>Submitting this form will enable you to assign a development environment to your integration.</DialogContentText>
        <DialogContentText>An Integration Review will be created for Skyward staff; you may receive correspondence regarding this process.</DialogContentText>
        <DialogContentText>Before submitting, please review the following points.</DialogContentText>
        <DialogContentText>Note that any integration data can be changed later if needed.</DialogContentText>
      </DialogContent>
      <DialogContent>
        <FormControlLabel
          label="The Name and Description are concise yet thorough; they serve to identify this Integration to non-technical Qmlativ users."
          control={<Checkbox checked={checkNameDescription} onChange={(_, checked) => setCheckNameDescription(checked)} />}
        />
      </DialogContent>
      <DialogContent>
        <FormControlLabel
          label="The Data Direction is correct - Import or Both should only be used if this Integration provides data that is stored in Qmlativ."
          control={<Checkbox checked={checkDataDirection} onChange={(_, checked) => setCheckDataDirection(checked)} />}
        />
      </DialogContent>
      <DialogContent>
        <FormControlLabel
          label="All of the APIs that this Integration is expected to use are selected."
          control={<Checkbox checked={checkAPIs} onChange={(_, checked) => setCheckAPIs(checked)} />}
        />
      </DialogContent>
      <DialogActions>
        <RawLinkButton onClick={handleSubmit} disabled={!isComplete || isSubmitting}>
          Begin Development
        </RawLinkButton>
        <RawLinkButton onClick={onClose}>Close</RawLinkButton>
      </DialogActions>
      {error && (
        <DialogContent>
          <DialogContentErrorText>{error}</DialogContentErrorText>
        </DialogContent>
      )}
    </Dialog>
  );
};
